import { Box, Paper, Typography } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import GppMaybeOutlinedIcon from "@mui/icons-material/GppMaybeOutlined";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";

const features = [
  {
    icon: <SearchOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Busca semântica",
    description: "Encontra artigos por conceito, não por palavra-chave.",
  },
  {
    icon: <ArticleOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "PubMed em tempo real",
    description: "Acesso direto às bases de dados científicas.",
  },
  {
    icon: <BarChartOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Meta-análises",
    description: "Síntese automática de evidências clínicas.",
  },
  {
    icon: <MedicationOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Dosagem individualizada",
    description: "Cálculos baseados em perfil farmacológico.",
  },
  {
    icon: <WarningAmberOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Interações medicamentosas",
    description: "Detecção via enzimas CYP450.",
  },
  {
    icon: <DescriptionOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Protocolos clínicos",
    description: "Guidelines internacionais e nacionais.",
  },
  {
    icon: <ScienceOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "CBD & THC",
    description: "Canabinoides, terpenos e entourage effect.",
  },
  {
    icon: <PsychologyOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Raciocínio clínico",
    description: "Diagnóstico diferencial com IA multiagente.",
  },
  {
    icon: <FileDownloadOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Exportação de laudos",
    description: "PDF pronto para prontuário.",
  },
  {
    icon: <StorageOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Histórico clínico",
    description: "Memória de pacientes e evoluções.",
  },
  {
    icon: <GppMaybeOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Contraindicações",
    description: "Análise automática de risco-benefício.",
  },
  {
    icon: <SyncOutlinedIcon sx={{ fontSize: 36, color: "#FF8904" }} />,
    title: "Atualização contínua",
    description: "Base científica sempre atualizada.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="funcionalidades" className="relative z-10 px-6 md:px-12 pb-20 md:pb-28">
      <div className="text-center mb-14">
        <Typography
          variant="h4"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            fontFamily: "Oxanium, sans-serif",
            letterSpacing: "-0.02em",
            marginBottom: "12px",
            fontSize: { xs: "1.5rem", md: "2rem" },
          }}
        >
          Tudo que você precisa para prescrever com confiança
        </Typography>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {features.map((feature) => (
          <Paper
            key={feature.title}
            elevation={0}
            sx={{
              background:
                "linear-gradient(135deg, rgba(26, 49, 60, 0.6) 0%, rgba(4, 9, 10, 0.8) 100%)",
              backdropFilter: "blur(16px)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: "24px",
              padding: "32px",
              transition: "all 0.3s ease",
              "&:hover": {
                border: "1px solid rgba(255, 137, 4, 0.25)",
                transform: "translateY(-4px)",
                boxShadow: "0 12px 40px rgba(0,0,0,0.3)",
              },
            }}
          >
            <Box sx={{ marginBottom: "16px" }}>{feature.icon}</Box>
            <Typography
              sx={{
                color: "#ffffff",
                fontWeight: 700,
                fontSize: "1.1rem",
                fontFamily: "Oxanium, sans-serif",
                marginBottom: "8px",
              }}
            >
              {feature.title}
            </Typography>
            <Typography
              sx={{
                color: "rgba(255,255,255,0.6)",
                fontSize: "0.95rem",
                lineHeight: 1.6,
              }}
            >
              {feature.description}
            </Typography>
          </Paper>
        ))}
      </div>
    </section>
  );
}
